import makeStyles from '@mui/styles/makeStyles';
import { getScrollStyles } from 'modules/common/styles';

export const useTextAreaScrollStyles = makeStyles((theme) => ({
  scrollBar: {
    '& .MuiInputBase-input': {
      cursor: 'auto',
      ...getScrollStyles(theme)
    }
  }
}));
